import React from 'react';
import { Box } from '@mui/material';
import { ConfigureInitializeState } from 'app/components/ReusableUIComponents/ConfigureInitializeState';

interface InitializeMessageContentProps {
  isInitializing: boolean;
  onInitialize: () => void;
}

const InitializeMessageContent = ({
  isInitializing,
  onInitialize,
}: InitializeMessageContentProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        px: 2,
        py: 4,
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 640 }}>
        <ConfigureInitializeState
          message="Message content has not been set up for this dealer yet. Initialize to create the default operation types for generating AI messages."
          onInitialize={onInitialize}
          initializing={isInitializing}
          buttonLabel="Initialize Message Content"
        />
      </Box>
    </Box>
  );
};

export default InitializeMessageContent;
